/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { TextFieldComponent } from './text-field';
export * from './text-field';
export * from './text-field-adapter';
export * from './text-field-constants';
export * from './text-field-core';
export * from './text-field-component-delegate';
export function defineTextFieldComponent() {
    defineCustomElement(TextFieldComponent);
}
